module.exports = __webpack_public_path__ + "static/media/edo.d3435422.png";